import { render, staticRenderFns } from "./appointList.vue?vue&type=template&id=4335fdc8&"
import script from "./appointList.vue?vue&type=script&lang=js&"
export * from "./appointList.vue?vue&type=script&lang=js&"
import style0 from "./appointList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports